var SupportGoodsShippingStatusAndNotesPresentation;

SupportGoodsShippingStatusAndNotesPresentation = {
  editable: {
    notes: "You can edit this order and your shipping details until it is processed.",
    status: "Processing",
    available: {
      fulfilled_enabled: {
        status: "Ordered",
        notes: "You can still make changes to this order until {{isEditableUntil}}"
      },
      shipments_available: {
        status: "Shipped",
        notes: I18n.translate('js.modules.notes.fine_print_otherwise_notes_message'),
        returnable: {
          notes: I18n.translate('js.modules.notes.fine_print_otherwise_notes_message'),
          return_initiated_label_not_printed: {
            status: "Returns Initiated",
            notes: "Your return for this item is currently in progress."
          },
          return_initiated_label_printed: {
            status: "Processing Returns",
            notes: "Your return for this item is currently in progress."
          }
        },
        not_returnable: {
          time_exceeded: {
            notes: I18n.translate('js.modules.notes.no_longer_returnable_notes_message')
          },
          non_returnable: {
            notes: I18n.translate('js.modules.notes.as_per_fine_print_notes_message')
          }
        }
      },
      shipments_processing: {
        status: "Ordered",
        notes: I18n.translate('js.modules.notes.tracking_info_not_available_notes_message'),
        returnable: {
          notes: I18n.translate('js.modules.notes.fine_print_otherwise_notes_message'),
          return_initiated_label_not_printed: {
            status: "Returns Initiated",
            notes: "Your return for this item is currently in progress."
          },
          return_initiated_label_printed: {
            status: "Processing Returns",
            notes: "Your return for this item is currently in progress."
          }
        }
      },
      shipments_not_available: {
        status: "Ordered",
        notes: I18n.translate('js.modules.notes.tracking_info_not_available_notes_message'),
        returnable: {
          notes: I18n.translate('js.modules.notes.fine_print_otherwise_notes_message'),
          return_initiated_label_not_printed: {
            status: "Returns Initiated",
            notes: "Your return for this item is currently in progress."
          },
          return_initiated_label_printed: {
            status: "Processing Returns",
            notes: "Your return for this item is currently in progress."
          }
        }
      }
    }
  },
  not_editable: {
    order_received: {
      status: "Ordered",
      dropship: {
        notes: "Your order was placed {{number_of_business_days_ago}} business days ago and can no longer be changed. You can expect to receive an email with tracking information within 2-4 business days of your purchase."
      },
      "post-deal_purchase_3pl": {
        notes: "Your order was placed {{number_of_business_days_ago}} business days ago and can no longer be changed. You can expect to receive an email with tracking information within 6-9 business days of your purchase."
      },
      "pre-deal_purchase_3pl": {
        notes: "Your order was placed {{number_of_business_days_ago}} business days ago and can no longer be changed. You can expect to receive an email with tracking information within 2-4 business days of your purchase."
      }
    },
    processing_order: {
      status: "Processing order",
      dropship: {
        notes: "You can expect to receive an email with tracking information within 2-4 business days of your purchase. Your order was placed {{number_of_business_days_ago}} business days ago and can no longer be changed."
      },
      "post-deal_purchase_3pl": {
        notes: "You can expect to receive an email with tracking information within 6-9 business days of your purchase. Your order was placed {{number_of_business_days_ago}} business days ago and can no longer be changed. "
      },
      "pre-deal_purchase_3pl": {
        notes: "You can expect to receive an email with tracking information within 2-4 business days of your purchase. Your order was placed {{number_of_business_days_ago}} business days ago and can no longer be changed."
      }
    },
    preparing_shipment: {
      status: "Preparing to Ship",
      dropship: {
        notes: "{{shipping_soon_msg_plus_two_business_days}} This order can no longer be changed."
      },
      "post-deal_purchase_3pl": {
        notes: "{{shipping_soon_msg}} This order can no longer be changed."
      },
      "pre-deal_purchase_3pl": {
        notes: "{{shipping_soon_msg_plus_two_business_days}} This order can no longer be changed."
      }
    },
    shipped: {
      status: "In Transit",
      dropship: {
        notes: "Your order shipped on {{shipped_date}} and is on its way to you!. You can expect delivery within 4-7 business days from this date."
      },
      "post-deal_purchase_3pl": {
        notes: "Your order shipped on {{shipped_date}} and is on its way to you!. You can expect delivery within 4-7 business days from this date."
      },
      "pre-deal_purchase_3pl": {
        notes: "Your order shipped on {{shipped_date}} and is on its way to you!. You can expect delivery within 4-7 business days from this date. Please allow up to 72 hours for tracking information to be available from the shipping company."
      }
    },
    out_for_delivery: {
      status: "Out for delivery",
      notes: "Your order is out for delivery on {{out_for_delivery_date}}!"
    },
    delivered: {
      status: "Delivered",
      notes: "Your order was delivered on {{delivered_date}}"
    },
    error: {
      status: "Shipped",
      notes: "Please visit {{carrier_name}} website for progress on you shipment. Your tracking number is {{tracking_number}}"
    },
    available: {
      shipments_available: {
        status: "Shipped",
        notes: I18n.translate('js.modules.notes.fine_print_otherwise_notes_message'),
        returnable: {
          notes: I18n.translate('js.modules.notes.fine_print_otherwise_notes_message'),
          return_initiated_label_not_printed: {
            status: "Returns Initiated",
            notes: "Your return for this item is currently in progress."
          },
          return_initiated_label_printed: {
            status: "Processing Returns",
            notes: "Your return for this item is currently in progress."
          }
        },
        not_returnable: {
          time_exceeded: {
            notes: I18n.translate('js.modules.notes.no_longer_returnable_notes_message')
          },
          non_returnable: {
            notes: I18n.translate('js.modules.notes.as_per_fine_print_notes_message')
          }
        }
      },
      shipments_processing: {
        status: "Processing order",
        notes: I18n.translate('js.modules.notes.tracking_info_not_available_notes_message'),
        returnable: {
          notes: I18n.translate('js.modules.notes.fine_print_otherwise_notes_message'),
          return_initiated_label_not_printed: {
            status: "Returns Initiated",
            notes: "Your return for this item is currently in progress."
          },
          return_initiated_label_printed: {
            status: "Processing Returns",
            notes: "Your return for this item is currently in progress."
          }
        }
      },
      shipments_not_available: {
        status: "Processing order",
        notes: I18n.translate('js.modules.notes.tracking_info_not_available_notes_message'),
        returnable: {
          notes: I18n.translate('js.modules.notes.fine_print_otherwise_notes_message'),
          return_initiated_label_not_printed: {
            status: "Returns Initiated",
            notes: "Your return for this item is currently in progress."
          },
          return_initiated_label_printed: {
            status: "Processing Returns",
            notes: "Your return for this item is currently in progress."
          }
        }
      }
    },
    redeemed: {
      status: "Used on <span class='localtime'>{{redeemed_date}}</span>",
      notes: ""
    },
    expired: {
      status: "Expired",
      notes: ""
    },
    expired_unredeemed: {
      status: "Expired",
      notes: ""
    },
    expired_redeemed: {
      status: "Used on <span class='localtime'>{{redeemed_date}}</span>",
      notes: ""
    }
  }
};

module.exports = SupportGoodsShippingStatusAndNotesPresentation;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvcHJlc2VudGVycy9nb29kc19zaGlwcGluZ19tZXNzYWdlcy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9ybXVydWdhbi9uYXBpc3RyYW5vL2J1aWxkLzE1MDE3ODIwMTYzMDYtNTk0MzUvcHJvZHVjdGlvbi0yMDE3LjA4LjAzXzE3LjM2L3N1cHBvcnRfYXBwL21vZHVsZXMvc3VwcG9ydC9mcm9udGVuZC9wcmVzZW50ZXJzL2dvb2RzX3NoaXBwaW5nX21lc3NhZ2VzLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLDhDQUFBLEdBQ0U7RUFBQSxRQUFBLEVBQ0U7SUFBQSxLQUFBLEVBQU8sMEVBQVA7SUFDQSxNQUFBLEVBQVEsWUFEUjtJQUdBLFNBQUEsRUFDRTtNQUFBLGlCQUFBLEVBQ0U7UUFBQSxNQUFBLEVBQVEsU0FBUjtRQUNBLEtBQUEsRUFBTyxvRUFEUDtPQURGO01BSUEsbUJBQUEsRUFDRTtRQUFBLE1BQUEsRUFBUSxTQUFSO1FBQ0EsS0FBQSxFQUFPLElBQUksQ0FBQyxTQUFMLENBQWUscURBQWYsQ0FEUDtRQUVBLFVBQUEsRUFDRTtVQUFBLEtBQUEsRUFBTyxJQUFJLENBQUMsU0FBTCxDQUFlLHFEQUFmLENBQVA7VUFFQSxrQ0FBQSxFQUNFO1lBQUEsTUFBQSxFQUFRLG1CQUFSO1lBQ0EsS0FBQSxFQUFPLHFEQURQO1dBSEY7VUFLQSw4QkFBQSxFQUNFO1lBQUEsTUFBQSxFQUFRLG9CQUFSO1lBQ0EsS0FBQSxFQUFPLHFEQURQO1dBTkY7U0FIRjtRQVlBLGNBQUEsRUFDRTtVQUFBLGFBQUEsRUFDRTtZQUFBLEtBQUEsRUFBTyxJQUFJLENBQUMsU0FBTCxDQUFlLHFEQUFmLENBQVA7V0FERjtVQUVBLGNBQUEsRUFDRTtZQUFBLEtBQUEsRUFBTyxJQUFJLENBQUMsU0FBTCxDQUFlLGtEQUFmLENBQVA7V0FIRjtTQWJGO09BTEY7TUF1QkEsb0JBQUEsRUFDRTtRQUFBLE1BQUEsRUFBUSxTQUFSO1FBQ0EsS0FBQSxFQUFPLElBQUksQ0FBQyxTQUFMLENBQWUsNERBQWYsQ0FEUDtRQUVBLFVBQUEsRUFDRTtVQUFBLEtBQUEsRUFBTyxJQUFJLENBQUMsU0FBTCxDQUFlLHFEQUFmLENBQVA7VUFFQSxrQ0FBQSxFQUNFO1lBQUEsTUFBQSxFQUFRLG1CQUFSO1lBQ0EsS0FBQSxFQUFPLHFEQURQO1dBSEY7VUFLQSw4QkFBQSxFQUNFO1lBQUEsTUFBQSxFQUFRLG9CQUFSO1lBQ0EsS0FBQSxFQUFPLHFEQURQO1dBTkY7U0FIRjtPQXhCRjtNQW9DQSx1QkFBQSxFQUNFO1FBQUEsTUFBQSxFQUFRLFNBQVI7UUFDQSxLQUFBLEVBQU8sSUFBSSxDQUFDLFNBQUwsQ0FBZSw0REFBZixDQURQO1FBR0EsVUFBQSxFQUNFO1VBQUEsS0FBQSxFQUFPLElBQUksQ0FBQyxTQUFMLENBQWUscURBQWYsQ0FBUDtVQUVBLGtDQUFBLEVBQ0U7WUFBQSxNQUFBLEVBQVEsbUJBQVI7WUFDQSxLQUFBLEVBQU8scURBRFA7V0FIRjtVQUtBLDhCQUFBLEVBQ0U7WUFBQSxNQUFBLEVBQVEsb0JBQVI7WUFDQSxLQUFBLEVBQU8scURBRFA7V0FORjtTQUpGO09BckNGO0tBSkY7R0FERjtFQXVEQSxZQUFBLEVBQ0U7SUFBQSxjQUFBLEVBQ0U7TUFBQSxNQUFBLEVBQVEsU0FBUjtNQUNBLFFBQUEsRUFDRTtRQUFBLEtBQUEsRUFBTywrTUFBUDtPQUZGO01BSUEsd0JBQUEsRUFDRTtRQUFBLEtBQUEsRUFBTywrTUFBUDtPQUxGO01BT0EsdUJBQUEsRUFDRTtRQUFBLEtBQUEsRUFBTywrTUFBUDtPQVJGO0tBREY7SUFXQSxnQkFBQSxFQUNFO01BQUEsTUFBQSxFQUFRLGtCQUFSO01BQ0EsUUFBQSxFQUNFO1FBQUEsS0FBQSxFQUFPLCtNQUFQO09BRkY7TUFJQSx3QkFBQSxFQUNFO1FBQUEsS0FBQSxFQUFPLGdOQUFQO09BTEY7TUFPQSx1QkFBQSxFQUNFO1FBQUEsS0FBQSxFQUFPLCtNQUFQO09BUkY7S0FaRjtJQXNCQSxrQkFBQSxFQUNFO01BQUEsTUFBQSxFQUFRLG1CQUFSO01BQ0EsUUFBQSxFQUNFO1FBQUEsS0FBQSxFQUFPLG1GQUFQO09BRkY7TUFJQSx3QkFBQSxFQUNFO1FBQUEsS0FBQSxFQUFPLDREQUFQO09BTEY7TUFPQSx1QkFBQSxFQUNFO1FBQUEsS0FBQSxFQUFPLG1GQUFQO09BUkY7S0F2QkY7SUFpQ0EsT0FBQSxFQUNFO01BQUEsTUFBQSxFQUFRLFlBQVI7TUFDQSxRQUFBLEVBQ0U7UUFBQSxLQUFBLEVBQU8sb0lBQVA7T0FGRjtNQUlBLHdCQUFBLEVBQ0U7UUFBQSxLQUFBLEVBQU8sb0lBQVA7T0FMRjtNQU9BLHVCQUFBLEVBQ0U7UUFBQSxLQUFBLEVBQU8sb09BQVA7T0FSRjtLQWxDRjtJQTRDQSxnQkFBQSxFQUNFO01BQUEsTUFBQSxFQUFRLGtCQUFSO01BQ0EsS0FBQSxFQUFPLDhEQURQO0tBN0NGO0lBZ0RBLFNBQUEsRUFDRTtNQUFBLE1BQUEsRUFBUSxXQUFSO01BQ0EsS0FBQSxFQUFPLGdEQURQO0tBakRGO0lBb0RBLEtBQUEsRUFDRTtNQUFBLE1BQUEsRUFBUSxTQUFSO01BQ0EsS0FBQSxFQUFPLGlIQURQO0tBckRGO0lBd0RBLFNBQUEsRUFDRTtNQUFBLG1CQUFBLEVBQ0U7UUFBQSxNQUFBLEVBQVEsU0FBUjtRQUNBLEtBQUEsRUFBTyxJQUFJLENBQUMsU0FBTCxDQUFlLHFEQUFmLENBRFA7UUFHQSxVQUFBLEVBQ0U7VUFBQSxLQUFBLEVBQU8sSUFBSSxDQUFDLFNBQUwsQ0FBZSxxREFBZixDQUFQO1VBRUEsa0NBQUEsRUFDRTtZQUFBLE1BQUEsRUFBUSxtQkFBUjtZQUNBLEtBQUEsRUFBTyxxREFEUDtXQUhGO1VBS0EsOEJBQUEsRUFDRTtZQUFBLE1BQUEsRUFBUSxvQkFBUjtZQUNBLEtBQUEsRUFBTyxxREFEUDtXQU5GO1NBSkY7UUFhQSxjQUFBLEVBQ0U7VUFBQSxhQUFBLEVBQ0U7WUFBQSxLQUFBLEVBQU8sSUFBSSxDQUFDLFNBQUwsQ0FBZSxxREFBZixDQUFQO1dBREY7VUFFQSxjQUFBLEVBQ0U7WUFBQSxLQUFBLEVBQU8sSUFBSSxDQUFDLFNBQUwsQ0FBZSxrREFBZixDQUFQO1dBSEY7U0FkRjtPQURGO01Bb0JBLG9CQUFBLEVBQ0U7UUFBQSxNQUFBLEVBQVEsa0JBQVI7UUFDQSxLQUFBLEVBQU8sSUFBSSxDQUFDLFNBQUwsQ0FBZSw0REFBZixDQURQO1FBR0EsVUFBQSxFQUNFO1VBQUEsS0FBQSxFQUFPLElBQUksQ0FBQyxTQUFMLENBQWUscURBQWYsQ0FBUDtVQUVBLGtDQUFBLEVBQ0U7WUFBQSxNQUFBLEVBQVEsbUJBQVI7WUFDQSxLQUFBLEVBQU8scURBRFA7V0FIRjtVQUtBLDhCQUFBLEVBQ0U7WUFBQSxNQUFBLEVBQVEsb0JBQVI7WUFDQSxLQUFBLEVBQU8scURBRFA7V0FORjtTQUpGO09BckJGO01Ba0NBLHVCQUFBLEVBQ0U7UUFBQSxNQUFBLEVBQVEsa0JBQVI7UUFDQSxLQUFBLEVBQU8sSUFBSSxDQUFDLFNBQUwsQ0FBZSw0REFBZixDQURQO1FBR0EsVUFBQSxFQUNFO1VBQUEsS0FBQSxFQUFPLElBQUksQ0FBQyxTQUFMLENBQWUscURBQWYsQ0FBUDtVQUVBLGtDQUFBLEVBQ0U7WUFBQSxNQUFBLEVBQVEsbUJBQVI7WUFDQSxLQUFBLEVBQU8scURBRFA7V0FIRjtVQUtBLDhCQUFBLEVBQ0U7WUFBQSxNQUFBLEVBQVEsb0JBQVI7WUFDQSxLQUFBLEVBQU8scURBRFA7V0FORjtTQUpGO09BbkNGO0tBekRGO0lBeUdBLFFBQUEsRUFDRTtNQUFBLE1BQUEsRUFBUSwwREFBUjtNQUNBLEtBQUEsRUFBTyxFQURQO0tBMUdGO0lBNkdBLE9BQUEsRUFDRTtNQUFBLE1BQUEsRUFBUSxTQUFSO01BQ0EsS0FBQSxFQUFPLEVBRFA7S0E5R0Y7SUFpSEEsa0JBQUEsRUFDRTtNQUFBLE1BQUEsRUFBUSxTQUFSO01BQ0EsS0FBQSxFQUFPLEVBRFA7S0FsSEY7SUFxSEEsZ0JBQUEsRUFDRTtNQUFBLE1BQUEsRUFBUSwwREFBUjtNQUNBLEtBQUEsRUFBTyxFQURQO0tBdEhGO0dBeERGOzs7QUFpTEYsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
